import React, { useState } from "react";
import { auth, db } from "../../../firebase";
import {
  RecaptchaVerifier,
  signInWithPhoneNumber,
} from "firebase/auth";
import { doc, setDoc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

const PhoneRegister = ({ role }) => {
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [confirmationResult, setConfirmationResult] = useState(null);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const setupRecaptcha = () => {
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier("recaptcha-container", { size: "invisible" }, auth);
    }
  };

  const generateAccountId = (role) => {
    const prefix = role === "agent" ? "A" : "U";
    return prefix + Math.floor(100000 + Math.random() * 900000);
  };

  const handleSendOtp = async () => {
    setupRecaptcha();
    try {
      const confirmation = await signInWithPhoneNumber(auth, "+91" + mobile, window.recaptchaVerifier);
      setConfirmationResult(confirmation);
      setMessage("OTP sent. Please check your phone.");
    } catch (error) {
      setMessage(error.message);
    }
  };

  const handleVerifyOtp = async () => {
    try {
      const result = await confirmationResult.confirm(otp);
      const user = result.user;

      const userRef = doc(db, "users", user.uid);
      const existingDoc = await getDoc(userRef);
      if (existingDoc.exists()) {
        setMessage("User already exists. Please login.");
        return;
      }

      const accountId = generateAccountId(role);
      const userData = {
        uid: user.uid,
        accountId,
        phoneNumber: user.phoneNumber,
        mobile: user.phoneNumber,
        username: user.phoneNumber,
        contact: user.phoneNumber,
        role,
        isActive: true,
        downloads: [],
        area: "",
        mandal: "",
        district: "",
        state: "",
        credits: role === "agent" ? 0 : undefined,
        printStyle: "",
      };

      await setDoc(userRef, userData);
      navigate("/complete-profile");
    } catch (error) {
      setMessage("Invalid OTP. Try again.");
    }
  };

  return (
    <>
      <input type="tel" className="form-control mb-2" placeholder="Mobile Number" value={mobile} onChange={(e) => setMobile(e.target.value)} />
      {!confirmationResult ? (
        <button className="btn btn-warning w-100" onClick={handleSendOtp}>
          Send OTP
        </button>
      ) : (
        <>
          <input type="text" className="form-control mt-2 mb-2" placeholder="Enter OTP" value={otp} onChange={(e) => setOtp(e.target.value)} />
          <button className="btn btn-success w-100" onClick={handleVerifyOtp}>
            Verify OTP & Register
          </button>
        </>
      )}
      <div id="recaptcha-container" className="mt-2"></div>
      {message && <div className="alert alert-info mt-2">{message}</div>}
    </>
  );
};

export default PhoneRegister;
